import { Pipe, PipeTransform } from '@angular/core';
import Moment from 'moment';
import { TranslateService } from '../translate/translate.service';

@Pipe({
    name: 'translateISODate',
    pure: false,
    standalone: false
})
export class TranslateISODatePipe implements PipeTransform {
	constructor(private _translate: TranslateService) {}

	transform(ISOdate: string, format: string) {
		if (!ISOdate || !format) {
			return;
		}
		// return Moment.parseZone(ISOdate).format();
		return Moment.parseZone(ISOdate).format(this._translate.instant(format));
	}
}
